<template>
  <div id="login-page">
      <!-- <v-btn :to="{path: '/'}" class="ma-2" color="orange darken-2" dark><v-icon darkleft>mdi-arrow-left</v-icon>Home Page</v-btn> -->
    <v-app id="inspire">
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
              <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                  <v-toolbar-title>Fire Watch 101 Login</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-form ref="login" v-model="valid" lazy-validation>
                    <v-text-field autocorrect="off" autocapitalize="none" prepend-icon="mdi-account" v-model="username" :rules="usernameRules" label="Username" required> </v-text-field>
                    <v-text-field autocorrect="off" autocapitalize="none" prepend-icon="mdi-lock" type="password" v-model="password" :rules="passwordRules" label="Password" required> </v-text-field>
                  </v-form>
                </v-card-text>
                <center>
                  <v-btn :disabled="!valid" :large="$vuetify.breakpoint.smAndUp" color="info" style="width:250px; margin-bottom:35px;" @click="login(username,password)"><v-icon left>mdi-lock</v-icon>Login</v-btn>                
                </center>
                <v-divider></v-divider>
                <center>
                  <v-btn color="info" style=" width:250px;" :to="{path: 'forgotPassword'}" text>Forgot password</v-btn>
                  <v-card-text>New to Fire Watch 101? <v-btn color="info" :to="{path: 'create-account'}" text>Create Account</v-btn></v-card-text>
                </center>
              </v-card>
            </v-flex>
        </v-layout>  
      </v-container>
    </v-app>
    <v-snackbar :color="snackbar.color" v-model="snackbar.show" timeout="3000">
      {{ snackbar.message }} 
      <v-btn text @click="snackbar.show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>


<script>
export default {
  data: () => ({
    name: 'Login',
    valid: true,
    username: '',
    password: '',
    loading: false,
    snackbar: {
      show: false,
      message: null,
      color: "primary"

    },
    usernameRules: [
        v => !!v || 'Username is required',
      ],
    passwordRules: [
        v => !!v || 'Password is required',
      ],

    }),
  created(){
    if (localStorage.username){
      this.$router.push('watchlist')
      return
    }
    window.scrollTo(0,0);
  },
  methods: {
    error(message){
      this.snackbar.show = true;
      this.snackbar.message = message;
      this.snackbar.color = "error";
    },
    async login(username, password){    
      if (!this.$refs.login.validate()){
        this.error("There is an error in the login form");
        return
      }
      this.loading = true;
      let deviceIdentifier = null;
      if (localStorage.deviceIdentifier){
        deviceIdentifier = localStorage.deviceIdentifier
      }

      const response = await fetch(localStorage.apiURL + "/app/auth", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
              username: username,
              password: password,
              uuid: null,
              model: null,
              deviceType: "webUI",
              osVersion: navigator.appVersion,
              manufacturer: null,
              device: deviceIdentifier
        })
      })
      const data = await response.json();

      if (!data.success){

        if (data.msg == 'usr not found'){
          this.username = null;
          this.password = null;
          this.error("User not found.....Please try again");

        } else if (data.msg == 'password'){
          this.password = null;
          this.error("Incorrect Password");

        } else {
          this.error("An error occured " + data.msg);
        }
      return
      }
      
      localStorage.deviceIdentifier = data.device;
      localStorage.username = data.username;
      localStorage.token = data.deviceID;
      localStorage.tokenID = data.tokenID;
      localStorage.userID = data.userID;

      location.reload();
    },
  }
}
</script>

<style scoped>
#login-header {
  text-align: center;
}
</style>